import { render, staticRenderFns } from "./TrenNumeroHoras.vue?vue&type=template&id=2a65e229"
import script from "./TrenNumeroHoras.vue?vue&type=script&lang=js"
export * from "./TrenNumeroHoras.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports